import { render, staticRenderFns } from "./round-card.vue?vue&type=template&id=33827345&scoped=true"
import script from "./round-card.vue?vue&type=script&lang=js"
export * from "./round-card.vue?vue&type=script&lang=js"
import style0 from "./round-card.vue?vue&type=style&index=0&id=33827345&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33827345",
  null
  
)

export default component.exports